import React from "react";

import Orders from "../../components/Orders";

const OrdersPage = () => {
  return <Orders />;
};

export default OrdersPage;
